"use strict";import{Underlay as e}from"./src/Underlay.js";import{defineElement as a}from"@spectrum-web-components/base/src/define-element.js";a("sp-underlay",e);
//# sourceMappingURL=sp-underlay.js.map
